import { CustomNode } from '../../../types';
import { fbAudienceIcon } from '../../../icons';

const DEFAULT_ICON = fbAudienceIcon;

export const fbAudienceConfig: CustomNode = {
  getNodeConfig() {
    return {
      icon: DEFAULT_ICON,
    };
  },
};
